import { newImageFromMTObject } from './image-experience-image';

export const addCropSettingsToCreativeImage = (imgObjMT) => {
  const imageObject = newImageFromMTObject(imgObjMT);

  imageObject.SourceWidth = imageObject.width;
  imageObject.SourceHeight = imageObject.height;

  imageObject.originalWidth = imageObject.width;
  imageObject.originalHeight = imageObject.height;
  imageObject.cropWidth = imageObject.width;
  imageObject.cropHeight = imageObject.height;
  imageObject.cropX = 0;
  imageObject.cropY = 0;
  imageObject.targetWidth = imageObject.width;
  imageObject.targetHeight = imageObject.height;

  return imageObject;
};
